import { render, staticRenderFns } from "./Salarysheet.vue?vue&type=template&id=be1b5214&"
import script from "./Salarysheet.vue?vue&type=script&lang=js&"
export * from "./Salarysheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports